<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item>分销设置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">分销设置</h2>
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top:16px;padding:24px;"
    >
      <div class="card-title">绑定时效</div>
      <div class="divider"></div>
      <div class="item">
        <div class="item-label">解绑客户关系</div>
        <div class="item-value">
          有效期
          <el-input
            v-model="time"
            placeholder=""
            @input="TimerSetTimeout"
          ></el-input>
          天结束后解绑
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top:16px;padding:24px;"
    >
      <div class="card-title">提现金额</div>
      <div class="divider"></div>
      <div class="item">
        <div class="item-label">最大提现金额</div>
        <div class="item-value">
          <el-input
            v-model="MaxWithdrawAmount.value"
            placeholder=""
            @input="changeAmount"
          ></el-input>
          元
        </div>
      </div>
    </div>

  </div>
</template>

<script>

let Timer = null       // 定时器
let TimerTime = 1000    // 定时器 等待时长

import { configureList, configureUpdate } from "@/api/operation";
export default {
  components: {

  },
  data() {
    return {
      ReferrerExpireTime: {},// 返佣过期时间
      MaxWithdrawAmount: {},// 最大提现金额
      time: 0,
    };
  },
  created() {
    this.fetchInfo()
  },
  methods: {
    fetchInfo() {
      configureList().then(res => {
        this.ReferrerExpireTime = res.list.find((v) => { return v.code == 'ReferrerExpireTime' })
        this.MaxWithdrawAmount = res.list.find((v) => { return v.code == 'MaxWithdrawAmount' })
        this.time = Math.floor(Number(this.ReferrerExpireTime.value) / (1000 * 60 * 60 * 24));

      })
    },
    TimerSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        let time = this.time * ((1000 * 60 * 60 * 24))
        this.ReferrerExpireTime.value = time + ""
        configureUpdate(this.ReferrerExpireTime).then(res => {
          this.$message.success(`修改成功`)
        })
      }, TimerTime)
    },
    changeAmount() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        configureUpdate(this.MaxWithdrawAmount).then(res => {
          this.$message.success(`修改成功`)
        })
      }, TimerTime)
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
}
.divider {
  border-bottom: 1px dashed #dcdfe6;
  margin: 15px 0;
}
.item {
  display: flex;
  align-items: center;
  .item-label {
    font-weight: 400;
    font-size: 14px;
  }
  .item-value {
    display: flex;
    white-space: nowrap;
    align-items: center;
    margin-left: 32px;
    .el-input {
      width: 110px;
      margin: 0px 16px;
    }
  }
}
</style>
